module.exports = __webpack_public_path__ + "img/39.f59bf7d1.png";